<kit-bs-table [kitModel]="componentModel"></kit-bs-table>
